<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>广告配置</span>
        </div>

        <el-card>
          <div slot="header" class="clearfix">
            <span>下载奖励开关</span>
          </div>
          <el-form class="demo-form-inline">
            <el-form-item label="最大等级">
              <el-switch
                v-model="formData.switch"
                active-text="开启"
                inactive-text="关闭"
              />
            </el-form-item>
            <el-form-item label="奖励">
              <Reward :value="formData.reward" />
            </el-form-item>
            <el-button v-permisaction="['config:advertConfig:add']" type="primary" @click="onSubmit()">保存</el-button>
          </el-form>
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>奖励</span>
          </div>
          <el-table :data="tableData" border stripe>
            <el-table-column prop="name" label="类型" width="200px">
              <template v-slot:default="scope">
                <el-select v-model.number="scope.row.type" placeholder="请选择">
                  <el-option
                    v-for="item in adType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="等级范围" width="200px">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.level_start" style="width: 43%" placeholder="最小等级" />
                -
                <el-input v-model.number="scope.row.level_end" style="width: 43%" placeholder="最大等级" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="体力范围" width="200px">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.spin_start" style="width: 43%" placeholder="最小等级" />
                -
                <el-input v-model.number="scope.row.spin_end" style="width: 43%" placeholder="最大等级" />
              </template>
            </el-table-column>
            <el-table-column prop="v" label="权重" width="200px">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.v" placeholder="权重" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="200px">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.name" placeholder="名称" />
              </template>
            </el-table-column>
            <el-table-column prop="trueId" label="trueId" width="200px">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.trueId" placeholder="trueId" />
              </template>
            </el-table-column>
            <el-table-column prop="trueId_ios" label="trueId_ios" width="200px">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.trueId_ios" placeholder="trueId_ios" />
              </template>
            </el-table-column>
            <el-table-column prop="sceneId" label="sceneId" width="200px">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.sceneId" placeholder="sceneId" />
              </template>
            </el-table-column>
            <el-table-column prop="sceneId_ios" label="sceneId_ios" width="200px">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.sceneId_ios" placeholder="sceneId_ios" />
              </template>
            </el-table-column>
            <el-table-column prop="max" label="最大次数" width="200px">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.max" placeholder="最大次数" />
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="200px">
              <template v-slot:default="scope">
                <el-select v-model.number="scope.row.status" placeholder="请选择">
                  <el-option
                    v-for="item in statusMap"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="cd" label="冷却时间(s)" width="200px">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.cd" placeholder="冷却时间(s)" />
              </template>
            </el-table-column>
            <el-table-column label="奖励" width="200px">
              <template v-slot:default="scope">
                <Reward :value="scope.row.reward[0].reward" />
                <!--                <el-input v-model.number="scope.row.reward[0].reward" placeholder="冷却时间(s)" />-->
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200px;">
              <template v-slot:default="scope">
                <el-button type="primary" size="mini" @click="drawerArr[scope.$index].visible = true">配置</el-button>
                <el-drawer
                  title="配置"
                  :visible.sync="drawerArr[scope.$index].visible"
                  direction="rtl"
                  size="600px"
                >
                  <el-form>
                    <el-row v-for="(p,i) in scope.row.reward" :key="i">
                      <el-form-item label="倍数" style="margin-top: 10px;">
                        <el-input v-model.trim="p.bet" style="width: 300px;" placeholder="倍数" />
                      </el-form-item>
                      <el-form-item label="次数" style="margin-top: 10px;">
                        <el-input v-model.number="p.time" style="width: 300px;" placeholder="次数" />
                      </el-form-item>
                      <el-form-item label="提示" style="margin-top: 10px;">
                        <el-input v-model="p.tips" style="width: 300px;" placeholder="提示" />
                      </el-form-item>
                      <!--                      <el-form :inline="true">-->
                      <!--                        <el-form-item style="margin-top: 10px;">-->
                      <!--                          <Reward :value="p.reward" />-->
                      <!--                        </el-form-item>-->
                      <!--                      </el-form>-->
                      <el-form :inline="true">
                        <el-form-item style="margin-top: 10px;">
                          {{ showGetConfig(p._config) }}
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;">
                          <el-button type="primary" style="margin-left: 16px;" @click="drawerArr3[scope.$index][i].visible = true">
                            权重配置
                          </el-button>
                          <el-drawer
                            title="权重配置"
                            :visible.sync="drawerArr3[scope.$index][i].visible"
                            direction="rtl"
                            :append-to-body="true"
                            size="750px"
                          >
                            <el-form :inline="true">
                              <el-row v-for="(pp,pi) in p._config" :key="pi">
                                <el-form-item label="道具" style="margin-top: 5px;">
                                  <el-select v-model.number="pp.type" filterable style="width: 130px;" placeholder="请选择">
                                    <el-option
                                      v-for="(item, index) in typesMap"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                                </el-form-item>

                                <el-form-item label="数量" style="margin-top: 5px;">
                                  <el-input v-model.number="pp.num" style="width: 130px;" placeholder="数量" />
                                </el-form-item>
                                <el-form-item label="权重" style="margin-top: 5px;">
                                  <el-input v-model.number="pp.v" style="width: 130px;" placeholder="权重" />
                                </el-form-item>
                                <el-form-item style="margin-top: 5px;">
                                  <el-button v-permisaction="['config:advertConfig:add']" type="danger" @click="removeReward2('_config',scope.$index, i, pi)">删除</el-button>
                                </el-form-item>
                              </el-row>
                              <el-form-item style="margin-top: 10px">
                                <el-button v-permisaction="['config:advertConfig:add']" type="primary" @click="addReward2('config',scope.$index, i)">+</el-button>
                              </el-form-item>
                            </el-form>
                          </el-drawer>
                        </el-form-item>
                      </el-form>
                      <el-form-item style="margin-top: 10px">
                        <el-button v-permisaction="['config:advertConfig:del']" type="danger" @click="removeReward3( scope.$index,i)">删除</el-button>
                      </el-form-item>
                    </el-row>
                    <el-form-item style="margin-top: 10px">
                      <el-button v-if="scope.row.reward.length <= 0" v-permisaction="['config:advertConfig:add']" type="primary" @click="addReward( scope.$index)">+</el-button>
                    </el-form-item>
                  </el-form>
                </el-drawer>
                <el-button type="danger" size="mini" style="margin-left: 15px;" @click="delEvent(scope.row.id, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button v-permisaction="['config:advertConfig:add']" style="margin-top: 10px" type="primary" @click="addEvent()">+</el-button>
          <el-button v-permisaction="['config:advertConfig:add']" style="margin-top: 10px" type="primary" @click="onSubmit2()">保存</el-button>
        </el-card>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delCardProcess } from '@/api/config/card-pro'
import { getRewardType } from '@/api/config/slot'
import { getRewardType as getRewardType1 } from '@/api/config/lucky-draw'
import { delAdCfg, getAdCfg, getAdSwitchCfg, updateAdCfg, updateAdSwitchCfg } from '@/api/config/ad-cfg'
import Reward from '@/components/Reward/index.vue'

export default {
  name: 'Ad',
  components: { Reward },
  data() {
    return {
      total: 0,
      options: [],
      drawerArr: [{ visible: false }],
      drawerArr2: { 0: [{ visible: false }] },
      drawerArr3: { 0: [{ visible: false }] },
      adType: [
        { label: '棋盘电视机', value: 1 },
        { label: '体力不足触发点', value: 2 },
        { label: '商城', value: 3 },
        { label: '金币不足', value: 4 },
        { label: '投筛子', value: 5 }
      ],
      statusMap: [
        { label: '关闭', value: 0 },
        { label: '开启苹果', value: 1 },
        { label: '开启安卓', value: 2 },
        { label: '开启全部', value: 3 }
      ],
      typesMap: [
        { label: '金币', value: 'coins' },
        { label: '体力', value: 'spins' },
        { label: '盾', value: 'shield' }
      ],
      rewardType: [],
      formData:
        {
          'switch': 0,
          'reward': [
            { 'propsId': 3, 'skin': 0, 'num': 1, rtype: 2 }
          ]
        },
      tableData: [],
      chessId: [],
      areaId: [],
      shield: [],
      sieve: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      this.formData.switch = this.formData.switch === true ? 1 : 0
      for (const i in this.formData.reward) {
        const reward = this.formData.reward[i]
        if (reward.propsId === 65) {
          this.formData.reward[i].num *= 10000
        }
      }
      const data = JSON.stringify(this.formData)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      console.log('data', data)
      updateAdSwitchCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit2() {
      const tableData = this.tableData
      for (const i in tableData) {
        const val = tableData[i]
        if (!val.name) {
          this.msgError('名称不能为空')
          return
        }
        if (val.level_start > val.level_end) {
          this.msgError('开始等级不能大于结束等级')
          return
        }
        if (val.spin_start > val.spin_end) {
          this.msgError('开始体力不能大于结束体力')
          return
        }
        if (!val.trueId) {
          this.msgError('trueId不能为空')
          return
        }
        if (!val.trueId_ios) {
          this.msgError('trueId_ios不能为空')
          return
        }
        if (val.cd < 0) {
          this.msgError('冷却时间不能小于0')
          return
        }

        for (const k in val.reward) {
          const reward = val.reward[k]
          reward.bet = parseFloat(reward.bet)
          const config = {}
          for (const j in reward._config) {
            const c = reward._config[j]
            config[c.type] = { num: c.num, v: c.v }
          }
          val.reward[k].conf = config
          val.reward[k]._config = []
        }

        tableData[i].reward = val.reward
      }
      const formData = JSON.stringify(tableData)
      updateAdCfg({ data: formData }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
      console.log('data', tableData)
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    getTables() {
      setTimeout(() => {
        this.getAdCfgList()
      }, 1000)

      getAdSwitchCfg().then(res => {
        if (res.code === 200) {
          if (res.data.reward === null) {
            res.data.reward = []
          } else {
            for (const i in res.data.reward) {
              const reward = res.data.reward[i]
              if (reward.propsId === 65) {
                res.data.reward[i].num /= 10000
              }
            }
          }
          res.data.switch = res.data.switch === 1
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getAdCfgList() {
      getAdCfg(this.queryParams).then(res => {
        if (res.code === 200) {
          const data = res.data.list
          this.drawerArr = []
          for (const i in data) {
            const val = data[i]
            this.drawerArr.push({ visible: false })
            this.$set(this.drawerArr2, i, [{ visible: false }])
            this.$set(this.drawerArr3, i, [{ visible: false }])
            for (const k in val.reward) {
              this.drawerArr2[i].push({ visible: false })
              this.drawerArr3[i].push({ visible: false })
              const reward = val.reward[k]
              const config = []
              for (const j in reward.conf) {
                const c = reward.conf[j]
                config.push({ type: j, num: c.num, v: c.v })
              }
              val.reward[k]._config = config
            }
            data[i] = val
          }
          this.tableData = data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.reward.push(
        { 'propsId': 14, 'skin': 0, 'num': 1, rtype: 2 }
      )
    },
    del(id, index) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCardProcess({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      }

      this.formData = this.formData.filter((item, key) => {
        return key !== index
      })
    },
    getRewardList() {
      getRewardType1({ id: 1 }).then(res => {
        if (res.code === 200) {
          this.options = res.data
        } else {
          console.log(res.msg)
        }
      })
    },
    removeReward(index) {
      this.formData.reward = this.formData.reward.filter((item, key) => {
        return index !== key
      })
    },
    removeReward3(index, i) {
      this.tableData[index].reward = this.tableData[index].reward.filter((item, key) => {
        return i !== key
      })
    },
    delEvent(id, index) {
      if (id > 0) {
        this.$confirm('你确定要删除该数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '再看看',
          type: 'warning'
        }).then(() => {
          delAdCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.tableData = this.tableData.filter((item, idx) => {
          return idx !== index
        })
      }
    },
    addEvent() {
      this.tableData.push({ type: 1, level_start: 0, level_end: 0, v: 0, trueId: '', trueId_ios: '', name: '', max: 0, reward: [{ bet: 0, time: 0, tips: '', reward: [], conf: [], _config: [] }], status: 1, group_pro: [], sceneId: '', sceneId_ios: '', cd: 0 })
      const len = this.tableData.length - 1
      this.drawerArr.push({ visible: false })
      this.$set(this.drawerArr2, len, [{ visible: false }])
      this.$set(this.drawerArr3, len, [{ visible: false }])
    },
    addReward(index) {
      this.tableData[index].reward.push({ bet: 1, time: 1, tips: '', reward: [], _config: [], conf: [] })
      this.drawerArr2[index].push({ visible: false })
      this.drawerArr3[index].push({ visible: false })
    },
    addReward2(key, index, idx) {
      if (key === 'config') {
        this.tableData[index].reward[idx]._config.push({ type: 'coins', num: 1, v: 1 })
      } else {
        this.tableData[index].reward[idx].reward.push({ 'propsId': 14, 'skin': 0, 'num': 1, rtype: 2 })
      }
    },
    removeReward2(key, index, idx, i) {
      this.tableData[index].reward[idx][key] = this.tableData[index].reward[idx][key].filter((item, k) => {
        return k !== i
      })
    },
    showGetConfig(config) {
      const arr = []
      for (const i in config) {
        const val = config[i]
        for (const k in this.typesMap) {
          const c = this.typesMap[k]
          if (c.value === val.type) {
            arr.push(c.label + '*' + val.num)
            break
          }
        }
      }
      return arr.join(',')
    } }
}
</script>

<style scoped>
</style>
